import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import TableList from "../../components/TableList";
import { ContextMenu } from "../../components/context-menu/context-menu";
import { MessengerBox } from "../../components/messenger-box/messenger-box";
import { CheckBox } from "../../components/checkboxes/check-box";
import { Popup } from "../../components/Popup/popup";
import { AppSettings } from "../../constants";
import SubcontractorInformation from "../Components/subcontractor-information";
import * as UnitHelper from "../../helper/unit-helper";
import * as SubcontractorActionType from "../constants";
import * as TradeActionType from "Trades/constants";

const defaultParams = {
  defaultSortName: "subcontractorName",
  defaultSortOrder: "ascending",
  sizePerPage: 10,
};

let defaultCheckedValues = [];
AppSettings.CLIENT_STATUS_VALUE.map((item) => {
  if (item.key !== AppSettings.CLIENT_STATUS.PENDING) {
    defaultCheckedValues.push(item.key);
  }
});

const TABLE_NAME = "SUBCONTRACTOR_LIST";

class ManageSubcontractors extends Component {
  static propTypes = {
    ManageSubcontractor: PropTypes.object,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    SubcontractorStore: PropTypes.object,
    TradeList: PropTypes.array,
    PageSizeReference: PropTypes.object,
  };
  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.SubcontractorStore.ManageSubcontractor.params.take,
    );

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.SubcontractorStore.ManageSubcontractor.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord:
        props.SubcontractorStore.ManageSubcontractor.params.totalRecord,
      data: props.SubcontractorStore.ManageSubcontractor.items,
      status: props.SubcontractorStore.ManageSubcontractor.params.status,
      isShowPopup: false,
      checkedValues: [],
      isDisplaySubcontractorInformation: false,
    };
  }

  componentWillMount() {
    this.setState({
      checkedValues: defaultCheckedValues,
    });
  }

  componentDidMount() {
    this.binding(
      this.objToParams({
        ...this.props.SubcontractorStore.ManageSubcontractor.params,
        take: this.state.sizePerPage,
      }),
    );

    const self = this;
    window.addEventListener("click", (e) => {
      if (
        document.getElementById("s1-popup") &&
        document.getElementById("s1-popup").contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById("popup-button") &&
          document.getElementById("popup-button").contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { ManageSubcontractor } = nextProps.SubcontractorStore;
    if (ManageSubcontractor) {
      this.setState({
        totalRecord: ManageSubcontractor.params.totalRecord,
        data: ManageSubcontractor.items,
        status: ManageSubcontractor.params.status,
        currentPage: ManageSubcontractor.params.skip,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage,
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: SubcontractorActionType.RESET_SUBCONTRACTOR,
      params: null,
    });
  }

  onBindingTrade = () => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_TRADE_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  toolTipSuperAdminActive = (item) => {
    return (
      <Tooltip id={item.id} className="in tooltip-siteone">
        <span>This subcontractors has never logged into the system</span>
      </Tooltip>
    );
  };

  customOwnerEmail(item) {
    if (item.ownerEmail === null || item.ownerEmail === "") {
      return <span> - </span>;
    } else {
      return <span>{item.ownerEmail}</span>;
    }
  }

  customRenderStatus(item) {
    switch (item.clientStatus) {
      case AppSettings.CLIENT_STATUS.PENDING:
        return (
          <div className="pill-indicators success">
            {item.clientStatusValue}
          </div>
        );
      case AppSettings.CLIENT_STATUS.ACTIVE:
        return (
          <div className="pill-indicators success">
            {item.clientStatusValue}
            {item.superAdminStatusValue === "Invited" && (
              <OverlayTrigger
                placement="top"
                overlay={this.toolTipSuperAdminActive(item)}
                delayHide={10}
                delayShow={500}
              >
                <i
                  style={{ color: "yellow" }}
                  className="fa fa-circle"
                  aria-hidden="true"
                />
              </OverlayTrigger>
            )}
          </div>
        );
      case AppSettings.CLIENT_STATUS.SUSPENDED:
        return (
          <div className="pill-indicators danger">{item.clientStatusValue}</div>
        );
      default:
        break;
    }
    return null;
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: "View subcontractor information",
        event: this.onViewSubcontractorInformation.bind(this),
      },
    ];

    if (item.ownerEmail === null || item.ownerEmail === "") {
      contextItem.push({
        title: "Invite super admin",
        event: this.onInviteSuperAdmin.bind(this),
      });
    }

    if (item.ownerEmail && item.superAdminStatusValue === "Invited") {
      contextItem.push({
        title: "Resend invitation mail",
        event: this.onResendInvitationFromMenu.bind(this),
      });
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onResendInvitationFromMenu = (e, item) => {
    this.onResendInvitation(item.subcontractorId, item.userId);
  };

  onInviteSuperAdmin(e, item) {
    this.props.history.push("/subcontractors/invite", item);
  }

  onViewSubcontractorInformation(e, item) {
    this.props.dispatch({
      type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
      params: {
        subId: item.subcontractorId,
      },
      callback: () => {
        this.setState({
          isDisplaySubcontractorInformation: true,
        });
      },
    });
  }

  customRenderBtnAction(item) {
    return (
      <a
        className="glyphicon glyphicon-option-vertical cls-table-black-icon"
        onClick={(e) => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  customRenderSuperAdmin(item) {
    if (item.ownerEmail === null || item.ownerEmail === "") {
      return <span>-</span>;
    } else {
      return <span>{item.ownerEmail}</span>;
    }
  }

  onResendInvitation = (subcontractorId, id) => {
    this.props.dispatch({
      type: SubcontractorActionType.RESEND_SUBCONTRACTOR_INVITE_ASYNC,
      params: {
        subId: subcontractorId,
        data: {
          redirectUrl: `${subcontractorId}/account/active-user`,
          userId: id,
        },
      },
      callback: () => {
        this.onCallbackSearch();
      },
    });
  };

  onAssignTradeToSubcontractor = (id, trades) => {
    let tradeIds = [];
    trades.map((trade) => {
      tradeIds.push(trade.value);
    });
    this.props.dispatch({
      type: SubcontractorActionType.ASSIGN_TRADE_TO_SUBCONTRACTOR_ASYNC,
      params: {
        subId: id,
        data: {
          tradeIds,
        },
      },
    });
  };

  onCallbackSearch = () => {
    const {
      status,
      defaultSortName,
      defaultSortOrder,
      currentPage,
      sizePerPage,
    } = this.state;

    this.props.dispatch({
      type: SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASYNC,
      params: {
        searchKey: this.search.value.trim(),
        sortField: defaultSortName,
        sortOrder: defaultSortOrder,
        status: status,
        skip: currentPage - 1,
        take: sizePerPage,
      },
    });
  };

  editSubcontractor = (params) => {
    this.props.dispatch({
      type: SubcontractorActionType.EDIT_SUBCONTRACTOR_ASYNC,
      params,
      callback: () => {
        this.props.dispatch({
          type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
          params: {
            subId: params.subcontractorId,
          },
          callback: () => {
            this.onCallbackSearch();
          },
        });
      },
    });
  };

  addContactPointSubcontractor = (params) => {
    this.props.dispatch({
      type: SubcontractorActionType.ADD_CONTACT_POINT_SUBCONTRACTOR_ASYNC,
      params,
      callback: () => {
        this.props.dispatch({
          type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
          params: {
            subId: params.subcontractorId,
          },
          callback: () => {
            this.onCallbackSearch();
          },
        });
      },
    });
  };

  removeContactPointSubcontractor = (params) => {
    this.props.dispatch({
      type: SubcontractorActionType.REMOVE_CONTACT_POINT_SUBCONTRACTOR_ASYNC,
      params,
      callback: () => {
        this.props.dispatch({
          type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
          params: {
            subId: params.subcontractorId,
          },
        });
      },
    });
  };

  binding(params) {
    this.props.dispatch({
      type: SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASYNC,
      params: params,
    });
  }

  objToParams(obj) {
    return {
      searchKey: this.search ? this.search.value.trim() : "",
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take,
    };
  }

  onSearch() {
    var params = this.objToParams(
      this.props.SubcontractorStore.ManageSubcontractor.params,
    );

    this.setState({
      checkedValues: defaultCheckedValues,
    });

    this.binding({
      ...params,
      status: "all",
      skip: 0,
    });
  }

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  onTableBinding(configTable) {
    var params = this.objToParams(
      this.props.SubcontractorStore.ManageSubcontractor.params,
    );

    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take,
    });
  }

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  onCloseSubcontractorInformation = () => {
    this.setState({
      isDisplaySubcontractorInformation: false,
    });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter((item) => item !== value),
          ],
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        },
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value],
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        },
      );
    }
  };

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? "" : data.toString();

    if (status !== "") {
      var params = this.objToParams(
        this.props.SubcontractorStore.ManageSubcontractor.params,
      );
      if (status.split(",").length === 2) {
        status = "all";
      }
      this.binding({
        ...params,
        status: status,
        skip: 0,
      });
    } else {
      this.setState({ data: [] });
    }
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage,
      },
      () => {
        this.props.dispatch({
          type: SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASYNC,
          params: {
            searchKey: this.search.value.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage,
          },
        });
      },
    );
  }

  onConfirmRemoveSuperAdmin = (modalCallback) => {
    this.props.dispatch({
      type: SubcontractorActionType.REMOVE_SUPER_ADMIN_FROM_SUBCONTRACTOR_ASYNC,
      params: {
        subId:
          this.props.SubcontractorStore.SubcontractorInformation
            .subcontractorId,
      },
      callback: () => {
        modalCallback();
        this.onCallbackSearch();
      },
    });
  };

  render() {
    const data = this.state.data;

    const column = [
      {
        field: "id",
        header: "id",
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "subcontractorName",
        header: "Company name",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "subcontractorEmail",
        header: "Company email",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "ownerEmail",
        header: "Super admin",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderSuperAdmin.bind(this),
      },
      {
        field: "clientStatusValue",
        header: "Status",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderStatus.bind(this),
      },
      {
        field: "",
        header: "",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "right",
        headerAlign: "right",
        customRender: this.customRenderBtnAction.bind(this),
        className: "column-action",
        columnClassName: "column-action",
      },
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord,
    };

    const customHeader = (
      <div className="table-header">
        <Row>
          <Col sm={12} md={12} className="text-right">
            <div className="box-search">
              <div className="input-group">
                <input
                  type="text"
                  id="txt-search-email"
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  className="form-control"
                  placeholder="company name/email"
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className="input-group-btn">
                  <button
                    onClick={this.onSearch.bind(this)}
                    className="btn btn-secondary"
                  >
                    <span className="fa fa-search" aria-hidden="true" />
                  </button>
                </span>
              </div>
            </div>

            <div className="manage-user-filter pull-right">
              <button
                onClick={this.onTogglePopupFilter}
                className="btn btn-secondary fa fa-filter btn-icon"
                id="popup-button"
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={(ref) => {
                    this.popup = ref;
                  }}
                >
                  {AppSettings.CLIENT_STATUS_VALUE.map((item) => {
                    let className = "checkbox-default";
                    if (item.key !== AppSettings.CLIENT_STATUS.PENDING) {
                      switch (item.key) {
                        case AppSettings.CLIENT_STATUS.ACTIVE:
                          className = "checkbox-success";
                          break;
                        case AppSettings.CLIENT_STATUS.SUSPENDED:
                          className = "checkbox-danger";
                          break;
                        default:
                          break;
                      }
                      return (
                        <CheckBox
                          checked={this.state.checkedValues.includes(item.key)}
                          onChecked={this.onChecked.bind(this)}
                          name="status"
                          className={className}
                          value={item.key}
                          label={item.value}
                          handleChange={this.handleChange}
                        />
                      );
                    }
                    return null;
                  })}
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id="manage-user">
        <div className="page-title clearfix">
          <h2 className="pull-left">
            Subcontractors ({this.state.totalRecord})
          </h2>
          <Link
            className="btn btn-primary btn-info btn-siteone pull-right btn-icon"
            to={"/subcontractors/search-company-name"}
          >
            <span className="fa fa-plus icon" />
            NEW
          </Link>
        </div>
        <TableList
          ref={(ref) => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
        />

        {this.state.isDisplaySubcontractorInformation && (
          <SubcontractorInformation
            show={this.state.isDisplaySubcontractorInformation}
            onClose={this.onCloseSubcontractorInformation}
            subcontractorInformation={
              this.props.SubcontractorStore.SubcontractorInformation
            }
            tradeSelectList={this.props.TradeList}
            onBindingTrade={this.onBindingTrade}
            onResendInvitation={this.onResendInvitation}
            onAssignTradeToSubcontractor={this.onAssignTradeToSubcontractor}
            editSubcontractor={this.editSubcontractor}
            addContactPointSubcontractor={this.addContactPointSubcontractor}
            removeContactPointSubcontractor={
              this.removeContactPointSubcontractor
            }
            onConfirmRemoveSuperAdmin={this.onConfirmRemoveSuperAdmin}
          />
        )}

        <ContextMenu
          ref={(ref) => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={(ref) => {
            this.msgBox = ref;
          }}
          title={AppSettings.LOGO_30}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SubcontractorStore: state.SubcontractorStore,
    TradeList: state.TradeStore.TradeList,
    PageSizeReference: state.BuilderStore.PageSizeReference,
  };
};

export default connect(mapStateToProps)(ManageSubcontractors);



// WEBPACK FOOTER //
// ./src/Subcontractors/Containers/manage-subcontractors.js